import { BodyCopy } from "../components/BodyCopy";
import { BankIcon, Button, Title } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { useStore } from "../store/globalState";
import { useSessionStore } from "../store/useSessionStore";
import { CloseLight } from "../assets/navIcons";

export interface DestinationAccountInfoProps {
  onClose: () => void;
}

export const DestinationAccountInfo: React.FC<DestinationAccountInfoProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { session } = useSessionStore();
  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, bodyCopy } = colorConfig;

  const partnerName = session.data?.partner?.name || "Partner";

  return (
    <section className="destination-info-slot">
      <header className="payout-details-header">
        <span className="payout-header-action" aria-hidden="true" />
        <Title title={t("destination.title")} align="center" color={bodyCopy} />
        <button
          type="button"
          className="payout-header-action payout-close-btn"
          aria-label={t("common.cancel")}
          onClick={onClose}
        >
          <CloseLight size={36} colors={[bodyCopy, bodyCopy]} />
        </button>
      </header>
      <section className="destination-info-icon">
        <BankIcon size={40} />
      </section>
      <BodyCopy className="destination-info-subtitle" textColor={bodyCopy}>
        <b>{t("destination.cannotChange")}</b>
      </BodyCopy>
      <BodyCopy className="destination-info-text" textColor={bodyCopy}>
        {t("destination.explanation", { partner: partnerName })}
      </BodyCopy>
      <Button
        size="large"
        background={backgroundBtn}
        color={textColorBtn}
        onClick={onClose}
      >
        {t("destination.gotIt")}
      </Button>
    </section>
  );
};
